import {ReactNode} from 'react';
import {Navigate} from 'react-router-dom';
import {testingApiAvailable} from '../features/testing-api-integration/config';

// FNP-1403: a route gate for the Autonomous Testing pages, which only work when
// this stage has a testing-api endpoint configured.
//
// ⚠️ THE BUG THIS EXISTS TO PREVENT. The `testingApiAvailable` gate was applied
// to the MENU and never to the ROUTER. In prod the nav group is not rendered, but
// `/synthetic-users`, `/test-runs` and the rest still RESOLVE — the page mounts,
// every query is disabled (`enabled: testingApiAvailable`), no client is built,
// and the operator gets a permanently empty page with no explanation. A bookmark,
// a link in a ticket, or a refresh all land there. An empty page is
// indistinguishable from a broken one.
//
// ⚠️ KEEP THIS IN STEP WITH `autonomousTestingGroup` in
// layout/menu-items/data/menus.tsx. Both read the same flag, and a page reachable
// by URL but absent from the menu is exactly the state this fixes.
//
// This deliberately does NOT decide whether Autonomous Testing SHOULD be
// available in prod — that is FNP-1402, and adding a prod endpoint is FNP-1005.
// It only stops the current answer from being served as a blank page.
export const RequireTestingApi = ({children}: { children: ReactNode }) => {

    if (!testingApiAvailable) {
        return <Navigate to='/dashboard' replace/>;
    }

    return children;
};
